import React, { useEffect, useState } from 'react';
import ShopifyBuyButton from './ShopifyBuyButton';
import { getShopifySettings } from '../lib/shopifyClient';

/**
 * SubscriptionBuyButton — Shopify Buy Button for a membership tier.
 *
 * Renders the Shopify component only when the tier has a shopify_product_id
 * AND global shop credentials are configured. Otherwise returns null so the
 * caller (SubscriptionPage) can fall back to the legacy Stripe checkout flow.
 *
 * The button label + gold styling matches the site design — Subscribe/Add.
 */
const subOptions = (isLegacy) => ({
  product: {
    contents: { img: false, title: false, price: false, options: false, description: false, button: true },
    styles: {
      product: { 'max-width': '100%', 'margin': '0' },
      button: {
        'background-color': isLegacy ? '#D4AF37' : '#FFFFFF',
        color: '#000000',
        'font-family': 'Outfit, sans-serif',
        'font-weight': '700',
        'letter-spacing': '0.08em',
        'text-transform': 'uppercase',
        'padding': '18px 22px',
        'width': '100%',
        'border-radius': '4px',
        ':hover': { 'background-color': isLegacy ? '#E5C048' : '#E0E0E0' },
        ':focus': { 'background-color': isLegacy ? '#E5C048' : '#E0E0E0' },
      },
    },
    text: { button: 'Subscribe Now' },
  },
  modalProduct: {
    contents: { img: false, imgWithCarousel: true, button: false, buttonWithQuantity: true },
    styles: {
      button: {
        'background-color': '#D4AF37',
        color: '#000000',
        ':hover': { 'background-color': '#E5C048' },
        ':focus': { 'background-color': '#E5C048' },
      },
    },
    text: { button: 'Subscribe' },
  },
  cart: {
    text: { total: 'Subtotal', button: 'Checkout' },
    styles: {
      button: {
        'background-color': '#D4AF37',
        color: '#000000',
        ':hover': { 'background-color': '#E5C048' },
        ':focus': { 'background-color': '#E5C048' },
      },
    },
  },
});

const SubscriptionBuyButton = ({ tier }) => {
  const [shop, setShop] = useState(null);
  useEffect(() => {
    let alive = true;
    getShopifySettings().then((s) => {
      if (alive) setShop(s);
    });
    return () => { alive = false; };
  }, []);

  if (!tier || !tier.shopify_product_id) return null;
  if (shop === null) return null;
  if (!shop.domain || !shop.token) return null;

  return (
    <div
      className="w-full"
      onClick={(e) => e.stopPropagation()}
      data-testid={`subscription-buy-${tier.tier}`}
    >
      <ShopifyBuyButton
        shopDomain={shop.domain}
        storefrontToken={shop.token}
        componentType="product"
        componentId={tier.shopify_product_id}
        options={subOptions(tier.tier === 'legacy')}
      />
    </div>
  );
};

export default SubscriptionBuyButton;
